export default {
    setHTMLTemplate({commit}, payload) {
        commit('setHTMLTemplate', payload);
    },
    setHTMLTemplateLoaded({commit}, payload) {
        commit('setHTMLtemplateLoaded', payload);
    },
};